// Shared util helpers — date/time formatting, currency, status colors, CSV export
import { format, parse, parseISO } from "date-fns";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d5b26516-6148-4afd-b5ae-e35df53d35a8/artifacts/4c3xyjij_The%20Palate%20Stories%20LOGO_B2i%20%281%29%20%282%29.jpg";

export const STATUSES = [
  "New", "Confirmed", "In Production", "Ready",
  "Out for Delivery", "Delivered", "Cancelled", "Lost",
];

export const DELIVERY_TYPES = ["Pickup", "Delivery"];
export const DELIVERY_PARTNERS = ["Self Pickup", "Uber", "Porter", "Swiggy Genie", "Self Delivery", "Other"];
export const PAYMENT_METHODS = ["UPI", "Cash", "Bank Transfer", "Card", "Other"];
export const PAYMENT_STATUSES = ["Not Paid", "Advance Paid", "Fully Paid"];
export const EXPENSE_CATEGORIES = [
  "Ingredients", "Packaging", "Delivery", "Rent", "Electricity",
  "Staff", "Marketing", "Equipment", "Miscellaneous",
];

export const OCCASIONS = [
  "Birthday", "Anniversary", "Wedding", "Engagement", "Baby Shower",
  "Bridal Shower", "Corporate", "Festival", "Other",
];
export const SHAPES = ["Round", "Square", "Rectangle", "Heart", "Custom"];
export const TIERS = ["Single", "2-Tier", "3-Tier", "4-Tier"];
export const PRIORITY = ["Normal", "Urgent"];

export const FLAVOURS = [
  "Vanilla Pineapple",
  "Vanilla Biscoff",
  "Vanilla Chocolate",
  "Vanilla Butterscotch",
  "Vanilla Mixfruit",
  "Vanilla Blueberry",
  "Vanilla Caramel",
  "Chocolate Truffle",
  "Chocolate Oreo",
  "Chocolate Biscoff",
  "Chocolate Mousse",
  "Chocolate Coffee",
  "Other / Custom Flavour",
];

export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = s.length === 10 ? parse(s, "yyyy-MM-dd", new Date()) : parseISO(s);
    return format(d, "dd MMM yyyy");
  } catch { return s; }
}

export function fmtTime(s) {
  if (!s) return "—";
  try {
    const d = parse(s, "HH:mm", new Date());
    return format(d, "h:mm a");
  } catch { return s; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "dd MMM yyyy, h:mm a"); } catch { return iso; }
}

export function inr(n) {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function todayISO() { return format(new Date(), "yyyy-MM-dd"); }

export async function compressImage(file, maxW = 1200, quality = 0.78) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = () => { img.src = reader.result; };
    reader.onerror = reject;
    img.onload = () => {
      const scale = Math.min(1, maxW / img.width);
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);
      const c = document.createElement("canvas");
      c.width = w; c.height = h;
      c.getContext("2d").drawImage(img, 0, 0, w, h);
      resolve(c.toDataURL("image/jpeg", quality));
    };
    img.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// CSV download helper
export function downloadCSV(filename, rows) {
  // rows is array of objects with same keys (or array of arrays). First we build header.
  if (!rows || rows.length === 0) {
    const blob = new Blob([""], { type: "text/csv;charset=utf-8" });
    triggerDownload(blob, filename);
    return;
  }
  let csv = "";
  const headers = Object.keys(rows[0]);
  csv += headers.map(escapeCSV).join(",") + "\n";
  rows.forEach((r) => {
    csv += headers.map((h) => escapeCSV(r[h])).join(",") + "\n";
  });
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  triggerDownload(blob, filename);
}

function escapeCSV(v) {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (s.includes(",") || s.includes('"') || s.includes("\n")) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Month label like "June 2026"
export function monthLabel(ym) {
  // ym is "YYYY-MM"
  try {
    const d = parse(ym + "-01", "yyyy-MM-dd", new Date());
    return format(d, "MMMM yyyy");
  } catch { return ym; }
}
